export default "__VITE_ASSET__58f32085__"